/**
 * Product events for the Word add-in. Names already used in PostHog stay:
 * `word_addin_loaded`, `word_addin_tab_changed`, `word_addin_insert_succeeded`,
 * and the web app's `message_sent_to_chat`. `word_addin_insert_failed` is the
 * failure pair, so a refused write is not counted as a success.
 *
 * Properties are labels and counts. The message text, the document, and any
 * error string stay out of the event.
 */
import posthog from "posthog-js";

import { type InsertTally } from "./analyticsEvents";

export type WordTab = "chat" | "tender";

const capture = (event: string, properties?: Record<string, string | number | boolean>): void => {
  try {
    posthog.capture(event, properties);
  } catch {
    // A telemetry failure must not break the pane.
  }
};

export const trackWordTabChanged = (tab: WordTab): void => {
  capture("word_addin_tab_changed", { tab });
};

/** A chat message sent from the pane. `via` says which control sent it. */
export const trackMessageSent = (via: string): void => {
  capture("message_sent_to_chat", { via, client: "word" });
};

export const trackInsert = (kind: string, tally: InsertTally): void => {
  if (tally.succeeded > 0) {
    capture("word_addin_insert_succeeded", { kind, count: tally.succeeded });
  }
  if (tally.failed > 0) {
    capture("word_addin_insert_failed", { kind, count: tally.failed });
  }
};
